<div class="darkmode absolute 2xl:right-[10px] right-[7px] top-[60px]">
  <label class="swap swap-rotate">
    <input type="checkbox" class="theme-controller" value="synthwave" (click)="toggleTheme()" />
    <svg class="swap-on fill-current w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z" />
    </svg>
    <svg class="swap-off fill-current w-6 h-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path
        d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z" />
    </svg>
  </label>
</div>
<div>
  <div class="topbar bg-primary p-1">
    <div class="flex justify-center items-center">
      <ul class="flex text-white justify-center text-xl items-center gap-x-5">
        <ng-container *ngFor="let socialLink of socialLinks">
          <li>
            <a href="{{socialLink.url}}" target="_blank" class="text-white">
              <i class="fab fa-{{socialLink.icon}}"></i>
            </a>
          </li>
        </ng-container>
      </ul>
    </div>
  </div>
  <div class="shadow-md">
    <div class="container mx-auto ">
      <div class="navbar bg-base-100 justify-between w-full">
        <div>
          <div class="dropdown lg:hidden" #dropdown>
            <div tabindex="0" role="button" class="btn btn-ghost">
              <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24"
                stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 6h16M4 12h8m-8 6h16" />
              </svg>
            </div>
            <ul tabindex="0" class="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
              <!-- <li class="relative"><a (click)="handleClick()" routerLinkActive="text-primary" routerLink="/latest-event">Events</a> </li> -->
              <li><a routerLink="/beyond" routerLinkActive="text-primary">Beyond</a></li>
              <li><a routerLink="/transcend-india" routerLinkActive="text-primary">Transcend India</a></li>
              <li><a routerLink="/evolve-india" routerLinkActive="text-primary">Evolve India</a></li>
              <li><a routerLink="/disrupt-kerala" routerLinkActive="text-primary">Disrupt Kerala</a></li>
              <li><a (click)="handleClick()" routerLinkActive="text-primary" routerLink="/speakers">Speakers</a></li>
              <li><a (click)="handleClick()" routerLinkActive="text-primary" routerLink="/gallery">Gallery</a></li>
              <li><a (click)="handleClick()" routerLinkActive="text-primary" routerLink="/contact">Contact</a></li>
            </ul>
          </div>
          <a class="text-xl w-[130px] xl:w-[200px]" routerLink="/">
            <img [src]="currentTheme === 'dark' ? darkLogoPath : logoPath" alt="Faya Port:80">
          </a>
          <a class="ml-0 md:ml-4 pl-[15px] md:pl-[23px] xl:pl-[43px] pb-[4px] xl:pb-[6px] w-[130px] xl:w-[195px] cursor-pointer" target="_blank" href="https://www.purple-movement.com/">
            <img class="w-full" src="assets/images/purple-logo.png">
          </a>
        </div>
        <div class="mr-0 mr lg:mr-6 hidden lg:flex ">
          <ul class="menu menu-horizontal px-1">
            <!-- <li class="relative group" >
              <a routerLinkActive="text-primary">Events</a>
              <ul class="absolute ml-0 pl-0 left-0 mt-2 hidden group-hover:block bg-white rounded-lg z-10 top-[25px] w-[200px] shadow-lg">
                <li><a class="block py-2 hover:bg-gray-100">Beyond</a></li>
                <li><a class="block py-2 hover:bg-gray-100">Transcend India</a></li>
                <li><a class="block py-2 hover:bg-gray-100">Evolve India</a></li>
                <li><a class="block py-2 hover:bg-gray-100">Disrupt Kerala</a></li>
              </ul>
            </li> -->
            <li><a class="px-[14px]" routerLink="/beyond" routerLinkActive="text-primary">Beyond </a></li>
            <li><a class="px-[14px]" routerLink="/transcend-india" routerLinkActive="text-primary">Transcend India</a></li>
            <li><a class="px-[14px]" routerLink="/evolve-india" routerLinkActive="text-primary">Evolve India</a></li>
            <li><a class="px-[14px]" routerLink="/disrupt-kerala" routerLinkActive="text-primary">Disrupt Kerala</a></li>
            <li><a class="px-[14px]" routerLink="/speakers" routerLinkActive="text-primary">Speakers</a></li>
            <li><a class="px-[14px]" routerLink="/gallery" routerLinkActive="text-primary">Gallery</a></li>
            <li><a class="px-[14px]" routerLink="/contact" routerLinkActive="text-primary">Contact</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>

